<template>
  <div class="manage">
    <div class="content">
      <ManagerHead :ruleForm="ruleForm"></ManagerHead>
      <el-dialog custom-class="custem" :title="operateType === 'add' ? '里程桩号' : '里程桩号'" :visible.sync="isShow">
        <EditTable :edit="edit" :ruleForm="ruleForm" @setZzjgBh="setZzjgBh"></EditTable>
        <div slot="footer" class="dialog-footer">
          <el-button @click="isShow = false">取 消</el-button>
          <el-button v-show="edit" type="primary" @click="confirm">确 定</el-button>
        </div>
      </el-dialog>
      <!-- <div style="position: absolute;top:15%;width: 15%;right: 10%;z-index: 9;">
          <el-tree :data="data" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
      </div> -->
      <div style="width:100%; height: 85%">
      <common-table 
            :lineWidth="80"
            :formLabel="Label" 
            :tableData="tableData" 
            :tableLabel="tableLabel" 
            :config="config" 
            @changePage="changePage" 
            @edit="editUser" 
            @del="delUser"
            @close="closeDeat" 
            @detail="detailUser"
            @open="openDeat"></common-table>
      </div>
    </div>
  </div>
</template>

<script>
import { FindLCZH, zZjG, AddLCZH } from '@/api/api'
import { mapState } from 'vuex'
import CommonForm from '../../components/CommonForm'
import CommonTable from '../../components/CommonTable'

import EditTable from '../../components/jobCard/liChengDetail'
import ManagerHead from '../../components/jobCard/liChengHead'
export default {
   computed: {
    ...mapState({
      zZjG: state => state.tab.zzjg,
      userInfo: state => state.tab.userInfo,
      showModel: state => state.tab.setMap,
    })
  },
  components: {
    CommonForm,
    CommonTable,
    EditTable,
    ManagerHead
  },
  data() {
    return {
      edit: false,
      data: [ ],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      SS:"",
      Label:{
        detail:true,
        add:true
      },
       ruleForm:{
          LCZHBH:"",
          LCZHMC:"",
          SSZZJG:"",
          ZZJGBH:"",
          GLS:"",
          JLS:"",
          GLS2:"",
          JLS2:"",
          XZB:"",
          YZB:"",
          XZB2:"",
          YZB2:"",
          SFZDGZ:"",
          XH:"",
          SCBZ:"",
          QYBZ:"",
          SFDGCX:1,
          INDEX: 0,
          COUNT: 20,
          project_id: ''
      },
      operateType: 'add',
      isShow: false,
      tableData: [],
      tableLabel: [
        {
          prop: 'ZZJGMC',
          label: '组织结构'
        },
        {
          prop: 'LCZHMC',
          label: '里程桩号名称',
        },
        // {
        //   prop: 'GLS',
        //   label: '公里数起点'
        // },
        // {
        //   prop: 'JLS',
        //   label: '距离数起点'
        // },
        // {
        //   prop: 'GLS2',
        //   label: '公里数止点'
        // },
        // {
        //   prop: 'JLS2',
        //   label: '距离数止点'
        // },
        {
          prop: 'XZB',
          label: 'X坐标'
        },
         {
          prop: 'YZB',
          label: 'Y坐标'
        }
      ],
      config: {
        page: 1,
        total: 10,
        loading: false
      },
      operateForm: {
        name: '',
        addr: '',
        age: '',
        birth: '',
        sex: ''
      },
      searchFrom: {
        keyword: ''
      },
      formLabel: [
        {
          model: 'keyword',
          label: ''
        }
      ]
    }
  },
  watch: {
    'showModel': {
      handler(n, o) {
        this.propsapi()
        this.getList()
      }
    }
  },
  methods: {
    propsapi() {
      // console.log(this.zy, '标段信息')
      if(this.showModel === null) {
				this.ruleForm.project_id = this.zZjG[0].MPROJECT_ID
			} else {
				this.ruleForm.project_id = this.showModel
			}
    },
     openDeat(row){
       this.$confirm('确定启用此用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success'
      })
      },
    closeDeat(row) {
       this.$confirm('确定禁用此用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })

    },
    setZzjgBh(e){
      this.SS = e
    },
    handleNodeClick(data) {
        this.ruleForm.SSZZJG = data.ZZJGBH
        this.ruleForm.INDEX = 0
        this.getList()
      },
    changePage(e){
      this.ruleForm.INDEX = e-1
      this.getList()
    },
    getList(e) {
      this.data = this.zZjG
      if(e!==undefined){
       this.ruleForm.LCZHMC = e.managerName
      }
      this.config.loading = true
      // 搜索时，页码需要设置为1，才能正确返回数据，因为数据是从第一页开始返回的
      name ? (this.config.page = 1) : ''
      FindLCZH(this.ruleForm).then(res => {
        if(res.data.ret!=="error"){
            res = JSON.parse(res.data.data)
            this.tableData = res
             this.config.total = Number(res[0].total) 
            this.config.loading = false
        }else{
          this.$message("没有查询到数据，请稍后再试！")
        }
      })
    },
    addUser() {
      this.ruleForm = {}
      this.operateType = 'add'
      this.edit = true
      this.isShow = true
    },
    editUser(row) {
      this.edit = true
      this.operateType = 'edit'
      this.isShow = true
      this.ruleForm = row
      
    },
     detailUser(row){
       this.isShow = true
       this.ruleForm = row
       this.edit = false
    },
     quite(){
      this.isShow = false
      if(this.edit){
        this.edit = false
      }else{
        this.edit = true
      }     
    },
    confirm() {
      if (this.operateType === 'edit') {
        this.ruleForm.SSZZJG = this.SS
          AddLCZH(this.ruleForm).then(res =>{
            if(res.data.ret==="ok"){
              this.$message("修改成功")
            }else{
              this.$message(this.$message(res.data.ret))
            }
        })
          this.isShow = false
          this.ruleForm = {}
           this.ruleForm.SSZZJG = this.userInfo.SSZZJG
          this.getList()
      } else {
        this.ruleForm.SSZZJG = this.SS
        AddLCZH(this.ruleForm).then(res =>{
             if(res.data.ret==="ok"){
                this.$message("添加成功")
              }else{
                this.$message(this.$message(res.data.ret))
              }
        })
          this.isShow = false
          this.ruleForm = {}
           this.ruleForm.SSZZJG = this.userInfo.SSZZJG
          this.getList()
      }
    },
    delUser(row) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let id = row.id
          this.$http
            .get('/api/user/del', {
              params: {
                id
              }
            })
            .then(res => {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getList()
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  },
  created() {
    this.ruleForm.SSZZJG = this.userInfo.SSZZJG
    this.getList()
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common';
@import '@/assets/scss/allPage';
.manage {
  padding: 20px;
  height: 100%;
  .content {
    width: 100%;
    height: 100%;
    background: rgba(50,58,82,0.25);
    border: 1px solid rgba(122,139,168,0.15);
    border-radius: 8px;
    opacity: 0.85;
  }
  & /deep/ .el-dialog__footer {
    background: #011e43;
    text-align: right;
    .el-button {
      color: #fff;
      width: 100px;
      border: 1px solid rgba(33,150,227,0.50);
      border-radius: 4px;
      margin: 0 10px;
    }
  }
}
</style>
